module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "APZ"
    }
  }, [_c('div', {
    staticClass: "image2",
    attrs: {
      "id": "pAeZ"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "id": "AeZ",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "pz6-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#con_pz6-1",
      "id": "toc_pz6-1"
    }
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz6-4"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("A")])]), _vm._v("s far back as I can remember, I have been fascinated with the words Jesus spoke. His conversations with His disciples, His answers to the Pharisees’ often trick questions, what He said when He performed His miracles, the penetrating, compelling statements in His teachings—even today all these words Jesus spoke continue to draw men and women to Him. The Gospels are filled with Jesus’ words, parables, and sermons. In a message consistent in all four Gospels, Jesus shows us the way to be saved, calls us to follow Him, and invites us to know rest and peace in His presence. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-6"
    }
  }, [_vm._v("Louis Klopsch (1852–1910) is credited with the idea of printing Jesus’ words in red. The editor of the "), _c('i', [_vm._v("Christian Herald")]), _vm._v(" magazine, Klopsch came up with the idea of printing some of the biblical text with red ink while he was reading Jesus’ words, “This cup is the new covenant in My blood, which is shed for you” (Luke 22:20). Klopsch decided to print all of Jesus’ words in red, the "), _c('span', {
    attrs: {
      "id": "z7-2"
    }
  }, [_vm._v("color of His blood. The first red-letter New Testament was printed in 1899, and the first red-letter Bible was printed in 1901 (“Origin of Red-Letter Bibles,” "), _c('i', [_vm._v("Crossway")]), _vm._v(". March 23, 2006. https://www.crossway.org/blog/2006/03/red-letter-origin/). ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz7-3"
    }
  }, [_vm._v("In this book, "), _c('i', [_vm._v("The Red Letter Words of Jesus")]), _vm._v(", I have chosen more than one hundred passages that reveal Jesus’ divine nature, His servanthood, and His love for all humankind. Jesus is the Giver of life, and in Him we can rest and be secure. Knowing Jesus through His words gives significance to our years on this earth and a peace that passes all understanding. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bacf20ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 69
// module chunks = 0